import type { ICarouselItem } from "../../../../types/models/carousel.models.types";
import { usePostHttp, useGetHttp, usePutHttp } from "../../http.hook";

export interface ICreateBody {
  action: {
    type: string;
    url?: string | null;
    navigation?: {
      target: string;
      extras?: Record<string, any> | null;
    } | null;
  };
  assetId: string;
}

interface ICreateResponse {
  carouselItem: ICarouselItem;
}

interface IGetByIdResponse {
  carouselItem: ICarouselItem;
}

interface IUpdateResponse {
  carouselItem: ICarouselItem;
}

interface IStatusResponse {
  carouselItem: ICarouselItem;
}

export function useCreateCarouselItemAdminHttp() {
  return usePostHttp<ICreateBody, ICreateResponse>({
    path: "/admin/carousel",
  });
}

export function useGetCarouselItemByIdAdminHttp() {
  return useGetHttp<IGetByIdResponse>({
    path: "/admin/carousel/:id",
  });
}

export function useUpdateCarouselItemAdminHttp() {
  return usePutHttp<Partial<ICreateBody>, IUpdateResponse>({
    path: "/admin/carousel/:id",
  });
}

export function usePublishCarouselItemAdminHttp() {
  return usePutHttp<null, IStatusResponse>({
    path: "/admin/carousel/:id/make-live",
  });
}

export function useArchiveCarouselItemAdminHttp() {
  return usePutHttp<null, IStatusResponse>({
    path: "/admin/carousel/:id/archive",
  });
}

export interface IUpdateOrderBody {
  carousel: {
    id: string;
    order: number;
  }[];
}

interface IUpdateOrderResponse {
  carousel: import("../../../../types/models/carousel.models.types").ICarouselOrderedItem[];
}

export function useUpdateCarouselOrderAdminHttp() {
  return usePutHttp<IUpdateOrderBody, IUpdateOrderResponse>({
    path: "/admin/carousel/order",
  });
}
